module.exports = __webpack_public_path__ + "media/images/malvinas/Sist_Malvinas_Positivo-f10abea28952633faf47236b06176d12.svg";